import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { NetworkingService } from '../networking.service';
import { API } from '../../data/api';
import { ClinicContentBlock } from '../../data/models/ClinicContentBlock';
import { ClinicContentBlockType } from '../../data/models/ClinicContentBlockType';

@Injectable({
  providedIn: 'root'
})
export class ContentBlockService {

  constructor(private networkingService: NetworkingService) {}

  getBlockTypes(): Observable<{ content_block_types: ClinicContentBlockType[] }> {
    return this.networkingService.getRequest(API.contentBlockTypeList)
  }

  getBlocks(): Observable<{ content_blocks: ClinicContentBlock[] }> {
    return this.networkingService.getRequest(API.contentBlockList)
  }

  createBlock(payload: any): Observable<ClinicContentBlock> {
    return this.networkingService.postRequest(API.contentBlockCreate, payload)
  }

  updateBlock(key: string, payload: any): Observable<ClinicContentBlock> {
    return this.networkingService.putRequest(API.contentBlockUpdate(key), payload)
  }

  reorderBlock(key: string, order: number): Observable<ClinicContentBlock[]> {
    return this.networkingService.putRequest(API.contentBlockReorder(key), { order })
  }

  togglePublishBlock(key: string): Observable<ClinicContentBlock> {
    return this.networkingService.putRequest(API.contentBlockTogglePublish(key))
  }

  toggleCollapsibleBlock(key: string): Observable<ClinicContentBlock> {
    return this.networkingService.putRequest(API.contentBlockToggleCollapsible(key))
  }

  deleteBlock(key: string): Observable<any> {
    return this.networkingService.deleteRequest(API.contentBlockDelete(key))
  }

  uploadMedia(key: string, file: File, preview?: File): Observable<ClinicContentBlock> {
    const formData = new FormData()
    formData.append('file', file)
    if (preview) formData.append('preview', preview)
    return this.networkingService.postRequest(API.contentBlockUploadMedia(key), formData)
  }
}
